export default __webpack_public_path__ + "static/media/We Could Be Heroes - Conway.bcebf437.mp3";